define(['jquery'], function ($) {
	var ERVChecks = function () {
	};
	ERVChecks.prototype.isMobileDevice = function () {
		return /Mobi|Android/i.test(navigator.userAgent);
	}

	ERVChecks.prototype.isIos = function () {
		return window.navigator.userAgent.match(/iPhone|iPod|iPad/i);
	}

	ERVChecks.prototype.isSafari = function () {
		return /^((?!chrome|CriOs).)*safari/i.test(navigator.userAgent);
	}

	ERVChecks.prototype.isCriOs = function () {
		return /iPhone(.*?CriOS)/i.test(navigator.userAgent);
	}

	ERVChecks.prototype.isIE = function () {
		var msIE = false;
		var ua = window.navigator.userAgent;
		var oldIE = ua.indexOf('MSIE ');
		var newIE = ua.indexOf('Trident/');

		if ((oldIE > -1) || (newIE > -1)) {
			msIE = true;
		}

		return msIE;
	}

	ERVChecks.prototype.isWebkitBrowser = function() {
		var self = this,
			isWebkit = 'WebkitAppearance' in document.documentElement.style;

		return isWebkit && !self.isIEEdge();
	}

	ERVChecks.prototype.isIEEdge = function () {
		return window.navigator.userAgent.indexOf("Edge") > -1;
	}

	ERVChecks.prototype.isInEpiEditMode = function () {
		return ($('body').hasClass('epi-editmode'));
	};

	ERVChecks.prototype.isDk = function () {
		return $('html').data('domain') === 'dk';
	}

	ERVChecks.prototype.isSe = function () {
		return $('html').data('domain') === 'se';
	}

	ERVChecks.prototype.isElementInViewport = function ($el, adjustHeight) {
		if (!$el || $el.length === 0) {
			return false;
		}

		var rect = $el[0].getBoundingClientRect();

		if (typeof (rect) === 'undefined' || rect == null) {
			return false;
		}

		adjustHeight = typeof (adjustHeight) === 'undefined' ? 0 : adjustHeight;

		return (
			rect.top >= 0 + adjustHeight &&
			rect.left >= 0 &&
			rect.bottom <= (window.innerHeight || $(window).height()) &&
			rect.right <= (window.innerWidth || $(window).width())
		);
	};

	return ERVChecks;
});